<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" 
  >
    <path d="M8,15c-3.9,0-7-3.1-7-7S4.1,1,8,1s7,3.1,7,7-3.1,7-7,7M8,16c4.4,0,8-3.6,8-8S12.4,0,8,0,0,3.6,0,8s3.6,8,8,8"/>
    <path fill-rule="evenodd" d="M9.7,3.6c.2.2.2.5,0,.7,0,0,0,0,0,0l-3.6,3.6,3.6,3.6c.2.2.2.5,0,.7s-.5.2-.7,0l-4-4c-.2-.2-.2-.5,0-.7,0,0,0,0,0,0l4-4c.2-.2.5-.2.7,0,0,0,0,0,0,0"/>
  </svg>
</template>
